/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { NamespaceIamRoleAuthorization } from '../model/namespaceIamRoleAuthorization';
import { NamespaceIamRoleAuthorizationCreateRequest } from '../model/namespaceIamRoleAuthorizationCreateRequest';
import { NamespaceIamRoleAuthorizationKeys } from '../model/namespaceIamRoleAuthorizationKeys';
import { NamespaceIamRoleAuthorizationUpdateRequest } from '../model/namespaceIamRoleAuthorizationUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class NamespaceIAMRoleAuthorizationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createNamespaceIamRoleAuthorization
     * Authorizes a namespace to use an IAM role.
     * @param namespaceIamRoleAuthorizationCreateRequest The namespace IAM role create request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationCreateNamespaceIamRoleAuthorization(namespaceIamRoleAuthorizationCreateRequest: NamespaceIamRoleAuthorizationCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorization>;
    public namespaceIAMRoleAuthorizationCreateNamespaceIamRoleAuthorization(namespaceIamRoleAuthorizationCreateRequest: NamespaceIamRoleAuthorizationCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationCreateNamespaceIamRoleAuthorization(namespaceIamRoleAuthorizationCreateRequest: NamespaceIamRoleAuthorizationCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationCreateNamespaceIamRoleAuthorization(namespaceIamRoleAuthorizationCreateRequest: NamespaceIamRoleAuthorizationCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespaceIamRoleAuthorizationCreateRequest === null || namespaceIamRoleAuthorizationCreateRequest === undefined) {
            throw new Error('Required parameter namespaceIamRoleAuthorizationCreateRequest was null or undefined when calling namespaceIAMRoleAuthorizationCreateNamespaceIamRoleAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<NamespaceIamRoleAuthorization>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations`,
            namespaceIamRoleAuthorizationCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteNamespaceIamRoleAuthorization
     * Removes a namespace IAM role authorization.
     * @param namespace The namespace
     * @param iamRoleName The IAM role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorization>;
    public namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization.');
        }
        if (iamRoleName === null || iamRoleName === undefined) {
            throw new Error('Required parameter iamRoleName was null or undefined when calling namespaceIAMRoleAuthorizationDeleteNamespaceIamRoleAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<NamespaceIamRoleAuthorization>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations/namespaces/${encodeURIComponent(String(namespace))}/iamRoleNames/${encodeURIComponent(String(iamRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespaceIamRoleAuthorization
     * Get the namespace IAM role authorization.
     * @param namespace The namespace
     * @param iamRoleName The IAM role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorization>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization.');
        }
        if (iamRoleName === null || iamRoleName === undefined) {
            throw new Error('Required parameter iamRoleName was null or undefined when calling namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NamespaceIamRoleAuthorization>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations/namespaces/${encodeURIComponent(String(namespace))}/iamRoleNames/${encodeURIComponent(String(iamRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespaceIamRoleAuthorizations
     * Get a list of namespace IAM role authorization keys.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizations(observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorizationKeys>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizations(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizations(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizations(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NamespaceIamRoleAuthorizationKeys>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespaceIamRoleAuthorizationsByIamRoleName
     * Get a list of namespace IAM role authorization keys by IAM role name.
     * @param iamRoleName The IAM role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByIamRoleName(iamRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorizationKeys>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByIamRoleName(iamRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByIamRoleName(iamRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByIamRoleName(iamRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (iamRoleName === null || iamRoleName === undefined) {
            throw new Error('Required parameter iamRoleName was null or undefined when calling namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByIamRoleName.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NamespaceIamRoleAuthorizationKeys>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations/iamRoleNames/${encodeURIComponent(String(iamRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getNamespaceIamRoleAuthorizationsByNamespace
     * Get a list of namespace IAM role authorization keys by namespace code.
     * @param namespace The namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByNamespace(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorizationKeys>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByNamespace(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByNamespace(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorizationKeys>>;
    public namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByNamespace(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling namespaceIAMRoleAuthorizationGetNamespaceIamRoleAuthorizationsByNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<NamespaceIamRoleAuthorizationKeys>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateNamespaceIamRoleAuthorization
     * Sets the IAM role description for a namespace IAM role authorization.
     * @param namespace The namespace
     * @param iamRoleName The IAM role name
     * @param namespaceIamRoleAuthorizationUpdateRequest The namespace IAM role update request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, namespaceIamRoleAuthorizationUpdateRequest: NamespaceIamRoleAuthorizationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<NamespaceIamRoleAuthorization>;
    public namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, namespaceIamRoleAuthorizationUpdateRequest: NamespaceIamRoleAuthorizationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, namespaceIamRoleAuthorizationUpdateRequest: NamespaceIamRoleAuthorizationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NamespaceIamRoleAuthorization>>;
    public namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization(namespace: string, iamRoleName: string, namespaceIamRoleAuthorizationUpdateRequest: NamespaceIamRoleAuthorizationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization.');
        }
        if (iamRoleName === null || iamRoleName === undefined) {
            throw new Error('Required parameter iamRoleName was null or undefined when calling namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization.');
        }
        if (namespaceIamRoleAuthorizationUpdateRequest === null || namespaceIamRoleAuthorizationUpdateRequest === undefined) {
            throw new Error('Required parameter namespaceIamRoleAuthorizationUpdateRequest was null or undefined when calling namespaceIAMRoleAuthorizationUpdateNamespaceIamRoleAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NamespaceIamRoleAuthorization>(`${this.configuration.basePath}/namespaceIamRoleAuthorizations/namespaces/${encodeURIComponent(String(namespace))}/iamRoleNames/${encodeURIComponent(String(iamRoleName))}`,
            namespaceIamRoleAuthorizationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
